/**
 * @generated SignedSource<<3ebdbad709fb25238f40bc364495804c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "usersMapSlug"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "usersMapUsersCount"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "usersMapUsersCursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "usersMapUsersFilters"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "usersMapSlug",
    "variableName": "usersMapSlug"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "usersMapUsersCursor"
  },
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "usersMapUsersFilters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "usersMapUsersCount"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  }
],
v6 = [
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "iconClass",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "contrastColor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "anchor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "anchorOffsetX",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "anchorOffsetY",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "opacity",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "image",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v5/*: any*/),
            "type": "Image",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v5/*: any*/),
            "type": "StaticImage",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "MapElementImageStyle",
    "abstractKey": "__isMapElementImageStyle"
  },
  (v3/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementIconStyle",
  "kind": "LinkedField",
  "name": "iconStyle",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementBackgroundStyle",
  "kind": "LinkedField",
  "name": "backgroundStyle",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v9 = [
  (v7/*: any*/),
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MapUsersPointsManagerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UsersMap",
        "kind": "LinkedField",
        "name": "usersMap",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MapUsersPoints_usersMap"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MapUsersPointsManagerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UsersMap",
        "kind": "LinkedField",
        "name": "usersMap",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "markersMaxClusterRadius",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "UserMarkerConnection",
            "kind": "LinkedField",
            "name": "usersMapUsersMarkers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserMarkerEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserMarker",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "userId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "usersGroupIds",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "latitude",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "longitude",
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "filters": [
              "filters"
            ],
            "handle": "connection",
            "key": "MapUsersPoints_usersMapUsersMarkers",
            "kind": "LinkedHandle",
            "name": "usersMapUsersMarkers"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UsersMapUsersGroup",
            "kind": "LinkedField",
            "name": "usersMapUsersGroups",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UsersGroup",
                "kind": "LinkedField",
                "name": "usersGroup",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MapElementPointStyle",
                "kind": "LinkedField",
                "name": "style",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "zIndexOffset",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MapElementZoomLevelStyle",
                    "kind": "LinkedField",
                    "name": "zoomLevels",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "zoomLevelMin",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "zoomLevelMax",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "style",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v9/*: any*/),
                            "type": "MapElementPointStyle",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v9/*: any*/),
                            "type": "MapElementCompoundFeatureStyle",
                            "abstractKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0a47c2673a5b619347a84e0331d91dd6",
    "id": null,
    "metadata": {},
    "name": "MapUsersPointsManagerQuery",
    "operationKind": "query",
    "text": "query MapUsersPointsManagerQuery(\n  $usersMapSlug: ID!\n  $usersMapUsersCount: Int!\n  $usersMapUsersCursor: String\n  $usersMapUsersFilters: UsersFiltersInput\n) {\n  usersMap(usersMapSlug: $usersMapSlug) {\n    ...MapUsersPoints_usersMap\n    id\n  }\n}\n\nfragment MapUsersPoints_usersMap on UsersMap {\n  markersMaxClusterRadius\n  usersMapUsersMarkers(first: $usersMapUsersCount, after: $usersMapUsersCursor, filters: $usersMapUsersFilters) {\n    edges {\n      node {\n        id\n        userId\n        usersGroupIds\n        ...UsersMapUserMarker_userMarker\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  usersMapUsersGroups {\n    usersGroup {\n      id\n    }\n    style {\n      zIndexOffset\n      iconStyle {\n        ... on MapElementImageStyle {\n          __isMapElementImageStyle: __typename\n          iconClass\n          color\n          contrastColor\n          width\n          height\n          anchor\n          anchorOffsetX\n          anchorOffsetY\n          opacity\n          image {\n            __typename\n            ... on Image {\n              url\n            }\n            ... on StaticImage {\n              url\n            }\n          }\n        }\n        id\n      }\n      backgroundStyle {\n        ... on MapElementImageStyle {\n          __isMapElementImageStyle: __typename\n          iconClass\n          color\n          contrastColor\n          width\n          height\n          anchor\n          anchorOffsetX\n          anchorOffsetY\n          opacity\n          image {\n            __typename\n            ... on Image {\n              url\n            }\n            ... on StaticImage {\n              url\n            }\n          }\n        }\n        id\n      }\n      zoomLevels {\n        zoomLevelMin\n        zoomLevelMax\n        style {\n          __typename\n          ... on MapElementPointStyle {\n            iconStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            backgroundStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n          }\n          ... on MapElementCompoundFeatureStyle {\n            iconStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            backgroundStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n          }\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  id\n}\n\nfragment UserMarkerTooltip_userMarker on UserMarker {\n  userId\n}\n\nfragment UsersMapUserMarker_userMarker on UserMarker {\n  userId\n  latitude\n  longitude\n  ...UserMarkerTooltip_userMarker\n}\n"
  }
};
})();

node.hash = "c368fa3d512244fcf91b9bcc1425cf34";

module.exports = node;
